import React, { useEffect, useState, useMemo } from "react";
import "./style.css";
import {
  CourseListApi,
  fetchCameragrouplistingApi,
  GetAttendenceApi,
  ScheduleListApi,
  UseCaseMappingAttendence,
} from "../../../api/api";
import { SkeletonCard } from "../../../context/Customfunction";

function LiveAttendence() {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState([]);
  const [professor, setProfessor] = useState([]);
  const [course, setCourse] = useState([]);
  const [semester, setSemester] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [sortBy, setSortBy] = useState("status");
  const [selectedCourseId, setSelectedCourseId] = useState();
  const [selectedRoomId, setSelectedRoomId] = useState("");
  const [selectedSemesterId, setSelectedSemesterId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [camera, setCamera] = useState([]);
  const [cameraurl, setCameraurl] = useState([]);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [zoomedMedia, setZoomedMedia] = useState({ type: null, url: null });
  const [selectedCameraId, setSelectedCameraId] = useState("");

  const [modetype, setModetype] = useState("default");
  const itemsPerPage = 100;
  const [isLive, setIsLive] = useState(false);

  const [selectedDate, setSelectedDate] = useState(() => {
    const now = new Date();
    return now.toISOString().slice(0, 19);
  });
  const [dateTimeString, setDateTimeString] = useState(() => {
    const now = new Date();
    return now.toISOString().split(".")[0]; // Full datetime like "2025-07-10T14:25:30"
  });

  const fetchInitialData = async () => {
    try {
      const [courseRes, roomRes, cameraGrp] = await Promise.all([
        CourseListApi(),
        ScheduleListApi(),
        fetchCameragrouplistingApi(),
      ]);
      if (courseRes?.data?.status) setCourse(courseRes.data.data);
      if (roomRes?.data?.status) setRooms(roomRes.data.data);
      if (cameraGrp?.data?.status) setSemester(cameraGrp?.data?.data);
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchFilteredAttendance = async () => {
    if (!selectedCourseId || !selectedDate) {
      setEventData([]);
      setProfessor([]);
      return;
    }

    setLoading(true);
    setCurrentPage(1);
    try {
      const res = await GetAttendenceApi(
        selectedDate,
        selectedCourseId,
        selectedRoomId,
        modetype
      );
      if (res?.data?.status === true) {
        setEventData(res.data.data.data);
        setProfessor(res.data.data);
      }
    } catch (error) {
      console.error("Attendance fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [sortBy]);

  useEffect(() => {
    fetchFilteredAttendance();
  }, [selectedCourseId, selectedRoomId, selectedSemesterId, selectedDate]);

  useEffect(() => {
    let intervalId;

    if (isLive) {
      fetchFilteredAttendance();
      intervalId = setInterval(() => {
        fetchFilteredAttendance();
      }, 10000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isLive, selectedCourseId, selectedDate, selectedRoomId]);

  const sortedData = useMemo(() => {
    let sorted = [...eventData];
    if (sortBy === "name") {
      sorted.sort((a, b) => a.student_name.localeCompare(b.student_name));
    } else if (sortBy === "status") {
      sorted.sort((a, b) => a.operation.localeCompare(b.operation));
    } else if (sortBy === "time") {
      sorted.sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      );
    }
    return sorted;
  }, [eventData, sortBy]);

  const visibleData = useMemo(() => {
    return sortedData.slice(0, currentPage * itemsPerPage);
  }, [sortedData, currentPage, itemsPerPage]);

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseMappingAttendence();
      //console.log("data", data);
      if (data?.data?.status === true) {
        setCamera(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
  }, []);

  const handleCameraGroupChange = (id) => {
    setSelectedCameraId(id);
    const selectedCamera = camera.find((ele) => ele.camera_grp_id === id);
    setCameraurl(selectedCamera);
    if (id == "686fd49b0541fce2ba3141fb") {
      // class-2 ground-shreya
      setSelectedCourseId("686f6399c6dbc80b4fa80f8b");
      // mba
    } else if (id == "686fd4f40541fce2ba3141fc") {
      //class-3 first floor
      setSelectedCourseId("686f5fe7c6dbc80b4fa80f87");
      // bba
    } else if (id == "686fd4600541fce2ba3141f9") {
      //claass-1 ground-saurabh
      setSelectedCourseId("685938b7bde215589047e919");
      // btech
    }
  };

  const handleGoLiveToggle = () => {
    const now = new Date();
    const currentDateTime = now.toISOString().split(".")[0]; // Get full ISO without milliseconds

    setIsLive((prev) => {
      const goingLive = !prev;
      if (goingLive) {
        setModetype("live");
        setDateTimeString(currentDateTime);
      } else {
        setModetype("default");
        setDateTimeString(`${selectedDate}T${currentDateTime.split("T")[1]}`);
      }
      return goingLive;
    });
  };

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <div className="col-xl-7">
            <h2 className="mb-0">Live Attendance</h2>
          </div>
          <div className="col-xl-5">
            <div className="d-flex gap-2">
              <div
                className="d-flex flex-column mt-0"
                style={{ minWidth: "140px" }}
              >
                {/* <label
                  htmlFor="dateFilter"
                  className="form-label mb-1"e
                  style={{ fontSize: "13px" }}
                >
                  Filter By Date
                </label> */}
                <input
                  id="dateFilter"
                  type="date"
                  className="form-control"
                  value={selectedDate.split("T")[0]}
                  onChange={(e) => {
                    const selected = new Date(e.target.value);
                    const now = new Date();
                    selected.setHours(now.getHours());
                    selected.setMinutes(now.getMinutes());
                    selected.setSeconds(now.getSeconds());
                    setSelectedDate(selected.toISOString().slice(0, 19));
                  }}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              {/* <select
                className="form-select"
                value={selectedCourseId}
                onChange={async (e) => {
                  const selectedId = e.target.value;
                  setSelectedCourseId(selectedId);
                }}
              >
                <option value="">Select Course</option>
                {course.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.course_name}
                  </option>
                ))}
              </select> */}

              <select
                className="form-select"
                value={selectedCameraId}
                onChange={(e) => handleCameraGroupChange(e.target.value)}
              >
                <option value="">Select Camera Group</option>
                {camera.map((item) => (
                  <option key={item.camera_grp_id} value={item.camera_grp_id}>
                    {item.camera_grp_name}
                  </option>
                ))}
              </select>

              {/* <select
                className="form-select"
                value={selectedRoomId}
                onChange={(e) => setSelectedRoomId(e.target.value)}
              >
                <option value="">Select Schedule</option>
                {rooms.map((room) => (
                  <option key={room._id} value={room._id}>
                    {room.schedule_name}
                  </option>
                ))}
              </select> */}
              <button
                className={`cancelBtn w-100 ${
                  isLive ? "btn-danger" : "royal-Green-btn"
                }`}
                type="button"
                onClick={handleGoLiveToggle}
              >
                {isLive ? "Stop Live" : "Go Live"}
              </button>
            </div>
          </div>
        </div>

        <div className="p-4">
          <h5 className="mb-3">B.Tech-Class Room01</h5>
          <div className="cameraGrid gridClass1x3">
            {cameraurl &&
              cameraurl?.cameras?.map((cam, idx) => (
                <div key={idx} className="image-box">
                  <img
                    src={cam.camera_live_url}
                    alt={cam.camera_live_url}
                    className="img-fluid rounded-top"
                    onClick={() =>
                      setZoomedMedia({
                        type: "video",
                        url: cam.camera_live_url,
                      })
                    }
                    style={{ cursor: "zoom-in" }}
                  />

                  <div className="text-center py-2">{cam.label}</div>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="rightSection bg-white border-start">
        <div className="titleFiltrer p-4 border-bottom">
          <h2 className="mb-2 mt-1">Details</h2>
        </div>
        <div className="px-4 py-3">
          <table className="table cstTable2 table-borderless m-0">
            <tbody>
              {/* <tr>
                <td>
                  <h5>Professor:</h5>
                  <p>{professor.professor_name}</p>
                </td>
                <td>
                  <h5>Subject:</h5>
                  <p>
                    {professor.subject_names?.map((ele) => (
                      <span key={ele} className="me-2">
                        {ele}
                      </span>
                    ))}
                  </p>
                </td>
              </tr> */}
              <tr>
                <td>
                  <h5>No. of Students:</h5>
                  <p>{professor.total_students}</p>
                </td>
                <td>
                  <h5>Available Students:</h5>
                  <p>
                    {professor.total_present}{" "}
                    <span className="text-danger">
                      ({professor.total_absent} Absent)
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr className="hr mt-0" />

        <div className="p-3">
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <h6 className="mb-0">Full Attendance</h6>
            <select
              className="form-select"
              style={{ width: "120px", fontSize: "13px" }}
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="status">Status</option>
              <option value="time">Time</option>
              <option value="name">Name</option>
            </select>
          </div>

          <div className="border-top cstAttandanceTable">
            {loading ? (
              Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
            ) : (
              <>
                <table className="table cstTable table-sm mb-0">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th style={{ width: "50px" }}>R.no</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Status</th>
                      <th style={{ width: "90px" }}>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleData.map((user, idx) => (
                      <tr key={user._id}>
                        <td>{String(idx + 1).padStart(2, "0")}</td>
                        <td>
                          <strong
                            className={
                              user.operation === "ABSENT" ? "text-danger" : ""
                            }
                          >
                            {user.student_name}
                          </strong>
                        </td>
                        <td>
                          <img
                            src={`https://visionemptrack.greymatterz.com/${user.image_dataset_path}`}
                            alt={user.name}
                            className="rounded-circle"
                            onClick={() =>
                              setZoomedImage(
                                `https://visionemptrack.greymatterz.com/${user.image_dataset_path}`
                              )
                            }
                            style={{
                              width: "75px",
                              height: "75px",
                              objectFit: "cover",
                              cursor: "zoom-in",
                            }}
                          />
                        </td>
                        <td>
                          <span
                            className={
                              user.operation === "ABSENT"
                                ? "text-danger"
                                : "text-success"
                            }
                          >
                            {user.operation}
                          </span>
                        </td>
                        <td>
                          {user.created_at
                            ? new Date(user.created_at).toLocaleTimeString(
                                "en-IN",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {visibleData.length < sortedData.length && (
                  <div className="text-center my-3">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {zoomedImage && (
        <div
          className="zoomed-image-overlay"
          onClick={() => setZoomedImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomedImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}

      {zoomedMedia.url && (
        <div
          className="zoomed-media-overlay"
          onClick={() => setZoomedMedia({ type: null, url: null })}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          {zoomedMedia.type === "video" ? (
            <img
              src={zoomedMedia.url}
              alt="Zoomed Video Feed"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(0,0,0,0.5)",
              }}
            />
          ) : (
            <img
              src={zoomedMedia.url}
              alt="Zoomed"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(0,0,0,0.5)",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default LiveAttendence;
